/* eslint-disable prefer-rest-params */
import type { Environment } from 'config/environment'

import { getFactorialData } from 'modules/core/lib/cookie'

function initGetSiteControl({ skipGetSiteControl }: Environment) {
  const { isFactorial } = getFactorialData() || {}

  if (skipGetSiteControl || isFactorial) return
  ;(function (w, d, s, u) {
    w.gsc =
      w.gsc ||
      function () {
        ;((w.gsc as any).q = (w.gsc as any).q || []).push(arguments)
      }

    const script: any = d.createElement(s)
    script.async = 1
    script.src = u

    const firstScript = d.getElementsByTagName(s)[0]
    firstScript?.parentNode?.insertBefore(script, firstScript)
  })(window, document, 'script', '//l.getsitecontrol.com/8wlp3kx7.js')
}

interface GetSiteControlData {
  environment: Environment
  doNotTrack: boolean
}

export default function runGetSiteControl({ environment, doNotTrack }: GetSiteControlData) {
  if (doNotTrack) return

  initGetSiteControl(environment)
}
